module.exports = __webpack_public_path__ + "img/10.120e1f5a.jpg";